import { useState, useEffect } from 'react';
import {
  extractKeywordsWithFrequency,
  formatKeywordData,
} from 'helpers/FormatKeywordsHelper';

export const useAdminClientTextForm = (currentRedaction, orderType, isLoading) => {
  // State values - même structure que Admin
  const [textTitle, setTextTitle] = useState('');
  const [keyword, setKeyword] = useState('');
  const [url, setUrl] = useState('');
  const [titleTag, setTitleTag] = useState('');
  const [metaDescriptionTag, setMetaDescriptionTag] = useState('');
  const [actualTextContent, setActualTextContent] = useState('');
  const [actualHtmlContent, setActualHtmlContent] = useState('');
  const [analyseText, setAnalyseText] = useState('');
  const [analyseResult, setAnalyseResult] = useState(null);
  const [keywords, setKeywords] = useState('');
  const [combinedKeywords, setCombinedKeywords] = useState('');
  const [combinedKeywordsList, setCombinedKeywordsList] = useState([]);
  const [stuffedKeywords, setStuffedKeywords] = useState([]);
  const [websites, setWebsites] = useState('');
  const [initialStuffedKeywords, setInitialStuffedKeywords] = useState([]);
  const [threadId, setThreadId] = useState('');
  const [initialTextContent, setInitialTextContent] = useState('');
  const [initialHtmlContent, setInitialHtmlContent] = useState('');
  const [list, setList] = useState({});


  useEffect(() => {
    if (!currentRedaction) return;

    setTextTitle(currentRedaction.textTitle || currentRedaction.title || currentRedaction.keyword || '');
    setKeyword(currentRedaction.keyword || '');
    setUrl(currentRedaction.url || '');
    setTitleTag(currentRedaction.titleTag || '');
    setMetaDescriptionTag(currentRedaction.metaDescriptionTag || '');
    setActualTextContent(currentRedaction.actualTextContent || '');
    setActualHtmlContent(currentRedaction.actualHtmlContent || '');
    setInitialTextContent(currentRedaction.initialTextContent || '');
    setInitialHtmlContent(currentRedaction.initialHtmlContent || '');
    setAnalyseText(
      currentRedaction.actualTextContent || currentRedaction.actualHtmlContent || ''
    );
    setStuffedKeywords(currentRedaction.stuffedKeywords || []);
    setWebsites(currentRedaction.internalLinking || '');

    if (currentRedaction.analyseResult) {
      try {
        const result = JSON.parse(currentRedaction.analyseResult);
        setAnalyseResult(
          typeof result === 'string' ? JSON.parse(result) : result
        );
      } catch (e) {
        console.error('Error parsing analyseResult', e);
      }
    }

    if (currentRedaction.semanticGap) {
      setKeywords(extractKeywordsWithFrequency(currentRedaction.semanticGap));
      setCombinedKeywords(formatKeywordData(currentRedaction.semanticGap));
      setList(currentRedaction.semanticGap);
    }
  }, [currentRedaction, isLoading]);

  return {
    // State values
    textTitle,
    keyword,
    url,
    titleTag,
    metaDescriptionTag,
    actualTextContent,
    actualHtmlContent,
    analyseText,
    analyseResult,
    keywords,
    combinedKeywords,
    list,
    stuffedKeywords,
    websites,
    initialStuffedKeywords,
    threadId,
    initialTextContent,
    initialHtmlContent,
    // Setters
    setTextTitle,
    setKeyword,
    setUrl,
    setTitleTag,
    setMetaDescriptionTag,
    setActualTextContent,
    setActualHtmlContent,
    setAnalyseText,
    setAnalyseResult,
    setKeywords,
    setCombinedKeywords,
    setCombinedKeywordsList,
    setList,
    setStuffedKeywords,
    setWebsites,
    setInitialStuffedKeywords,
    setInitialTextContent,
    setInitialHtmlContent,
  };
};
